import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, ms: number): T {
  const key = JSON.stringify(value);
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebounced(JSON.parse(key) as T);
    }, ms);
    return () => {
      window.clearTimeout(timer);
    };
  }, [key, ms]);
  return debounced;
}
